// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import { checkIsAllowToBookService } from '@/_helper/checkAccess';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import Form from './Form';
import HeroTeaser from '@/comp/heroTeaser';

// Styles
import './insurance.scss';

class Index extends Component {
    componentDidMount() {
        document.title = 'Versicherung' + window.$documentTitle;

        checkIsAllowToBookService('insurance');
    }

    render() {
        return (
            <div className="page-insurance">
                <Header />

                <HeroTeaser />

                <div className="content-wrapper">
                    <div className="intro row">
                        <h1 className="main-headline col">Versicherung</h1>
                    </div>

                    <div className="row">
                        <p className="text-max-width">
                            Falls Sie aufgrund von Krankheit Ihre Reise nicht antreten können, entstehen hohe Kosten für
                            die Stornierung. Sichern Sie sich jetzt mit dem passenden Reiseschutz dagegen ab.
                        </p>

                        <Form />
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default Index;
